import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { UserSessionService } from 'src/app/services/usersession.service';

@Injectable()
export class BCAuthGuard implements CanActivate {
    constructor(private router: Router,
        private userSessionService: UserSessionService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const isBCLoggedIn = localStorage.getItem('isBCLoggedin');
        // Check for the login state
        if (isBCLoggedIn) {
            return true;
        }
        this.router.navigate(['/auth']);
        return false;
    }
}
